import axios from "axios";

const EIQ_SERVER = import.meta.env.VITE_INSURANCE_API;

const apiInstance = axios.create({})

const getReport = async (plate, afm, usage, cc, transferDate, manufacturingDate, vendorGuid) => {
    const url = EIQ_SERVER + "/vehicle/diled"

    const data = { plate, afm, usage, cc, transferDate, manufacturingDate }
    if (vendorGuid) {
        data.vendorGuid = vendorGuid;
    }
    
    const resp = await apiInstance({ method: 'post', url: url, data })
    return resp.data
}

const getOptins = async (screenName) => {
    const url = EIQ_SERVER + "/optins"
    const resp = await apiInstance({ method: 'post', url: url, data: {screenName} })
    return resp.data
}

const getTermsLinks = async (body) => {
    const url = EIQ_SERVER + "/terms/links"

    const resp = await apiInstance({
        method: 'post',
        url: url,
        data: body
    })
    return resp.data
}

const getNeedsDocument = async (body) => {
    const url = EIQ_SERVER + "/terms/needsDocuments"

    const resp = await apiInstance({
        method: 'post',
        url: url,
        data:body
    })
    return resp.data
}

const fetchDisclaimers = async (request) => {
    const url = EIQ_SERVER + "/disclaimers";
    const resp = await apiInstance({ method: 'post', url, data: request });

    return resp.data;
};

const fetchBanners = async (request) => {
    const url = EIQ_SERVER + "/banners";
    const resp = await apiInstance({ method: 'post', url, data: request });

    return resp.data;
};

const fetchCustomerJourneyKey = async () => {
    const url = EIQ_SERVER + `/fields/key`;
    const resp = await apiInstance({method: 'get', url: url})

    return resp.data.customerJourneyKey;
};

const fetchOptins = async (request) => {
    const url = EIQ_SERVER + `/optins`;
    const resp = await apiInstance({method: 'post', url: url, data: request})

    return resp.data;
}

const quoteById = async (customerJourneyId) => {
    const url = PROXY_V2_SERVER + `/${customerJourneyId}`;
    const resp = await apiInstance({ method: 'get', url });

    return resp.data;
}

export {
    fetchBanners, fetchCustomerJourneyKey, fetchDisclaimers, fetchOptins, getOptins, getReport, getTermsLinks, quoteById, getNeedsDocument
};
